// Guarda de cobro (#1009): una empresa de autoalta que todavía no paga su
// licencia sólo puede ver «Elige tu licencia».
//
// Vive junto a las rutas (no dentro de un layout) para cubrir TODA la consola
// sin tocar cada árbol de rutas. No pinta nada: sólo redirige.
//
// Falla abierto: sin token, sin respuesta de la API o para cualquier empresa
// que no sea de autoalta, no hace nada.

import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import { fetchBillingStatus } from "./billingService";

/** Rutas que nunca se bloquean: login, alta, pago y páginas públicas. */
const OPEN_PREFIXES = [
  "/register",
  "/purchase",
  "/billing",
  // Bienvenida guiada (#1019): el asistente no depende del pago (también lo ve
  // quien entra sin pasarela) y no debe rebotar a «Elige tu licencia».
  "/bienvenida",
  // Verificación del alta manual (CC-CONSOLE#1550): va antes de todo lo demás.
  "/verificar",
  "/splash",
  // Soporte: quien no ha pagado debe poder pedir ayuda o cotizar.
  "/soporte",
  "/mis-tickets",
  // Su perfil (contraseña, cerrar sesión) siempre debe estar a mano.
  "/profile",
  "/camera",
  "/trackingLinks",
  "/confirm-session-reset",
  "/reset-password",
  "/shop",
  "/espacios",
  // Tienda pública de boletos de Gestión de Pasajeros (/rides/:slug).
  "/rides",
  "/tracking-replay",
  // Cotización pública del cliente (#1545).
  "/cotizacion",
  // Ticket de recoger en mostrador (QR) de ventas del POS.
  "/recoger",
];

export const PLANS_PATH = "/billing/plans";

export function isBillingOpenPath(pathname: string): boolean {
  if (pathname === "/" || pathname === "") return true;
  return OPEN_PREFIXES.some(
    (p) => pathname === p || pathname.startsWith(`${p}/`),
  );
}

export default function BillingGate() {
  const { pathname } = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (isBillingOpenPath(pathname)) return;
    if (!localStorage.getItem("token")) return;

    let active = true;
    fetchBillingStatus().then((status) => {
      if (active && status?.requiresPlan) {
        navigate(PLANS_PATH, { replace: true });
      }
    });
    return () => {
      active = false;
    };
  }, [pathname, navigate]);

  return null;
}
